<template>
  <div>
    <p v-if="forwarderLabel && answeringSequenceLabel" class="notification_label">Call failed to forward to {{ forwarderLabel }} in {{ answeringSequenceLabel }} Answering Sequence. Please contact support if you need help.</p>
    <p v-else class="notification_label">Call failed to forward in an Answering Sequence. Please contact support</p>
    <button-link @click="goToPhoneSettingsPage">Go to Phone Settings</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";

/**
 * NOTE: The if statement above is added because the forwarder_label was just added to data in Jan 2023,
 * and we need to support notifications that don't have it yet.
 */
export default {
  name: "CallFailedToDialForwarderNotification",
  props: {
    notification: Object
  },
  computed: {
    forwarderLabel() {
      if (this.notification.data.hasOwnProperty('forwarder_label')) {
        return this.notification.data.forwarder_label
      }
      return null
    },
    answeringSequenceLabel() {
      if (this.notification.data.hasOwnProperty('answering_sequence_label')) {
        return this.notification.data.answering_sequence_label
      }
      return null
    }
  },
  methods: {
    goToPhoneSettingsPage() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      });
      router.push('/settings/phone');
    },
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
